import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";

// Layout components
import Layout from "./components/layout/Layout";
import AuthLayout from "./components/layout/AuthLayout";

// Auth pages
import LoginPage from "./pages/auth/LoginPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";

// Dashboard pages
import DashboardPage from "./pages/dashboard/DashboardPage";

// Orders pages
import OrdersPage from "./pages/orders/OrdersPage";
import OrderDetailsPage from "./pages/orders/OrderDetailsPage";
import CreateOrderPage from "./pages/orders/CreateOrderPage";

// Menu pages
import MenuCategoriesPage from "./pages/menu/MenuCategoriesPage";
import MenuProductsPage from "./pages/menu/MenuProductsPage";
import ProductDetailsPage from "./pages/menu/ProductDetailsPage";
import CreateProductPage from "./pages/menu/CreateProductPage";

// Customer pages
import CustomersPage from "./pages/customers/CustomersPage";
import CustomerDetailsPage from "./pages/customers/CustomerDetailsPage";
//import CreateCustomerPage from "./pages/customers/CustomerPage";

// Inventory pages
import InventoryPage from "./pages/inventory/InventoryPage";
import InventoryItemPage from "./pages/inventory/InventoryItemPage";
//import InventoryTransactionsPage from "./pages/inventory/InventoryTransactionsPage";

// Reports pages
import ReportsPage from "./pages/reports/ReportsPage";
import SalesReportPage from "./pages/reports/SalesReportPage";
import ItemsReportPage from "./pages/reports/ItemsReportPage";
import RevenueReportPage from "./pages/reports/RevenueReportPage";
//import DeliveryReportPage from "./pages/reports/DeliveryReportPage";

// Settings pages
import SettingsPage from "./pages/settings/SettingsPage";
import PaymentMethodsPage from "./pages/settings/PaymentMethodsPage";
//import TaxesPage from "./pages/settings/TaxesPage";
//import OrderStatusesPage from "./pages/settings/OrderStatusesPage";

// Users pages
import UsersPage from "./pages/users/UsersPage";

// Error pages
import NotFoundPage from "./pages/errors/NotFoundPage";

// Guards
import AuthGuard from "./components/auth/AuthGuard";
import { AuthProvider } from "./context/AuthContext";

// Componente Root con AuthProvider
const RootLayout = () => {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      // Root redirect
      {
        path: "/",
        element: <Navigate replace to="/dashboard" />,
      },

      // Auth routes (public)
      {
        path: "/auth",
        element: <AuthLayout />,
        children: [
          {
            path: "login",
            element: <LoginPage />,
          },
          {
            path: "forgot-password",
            element: <ForgotPasswordPage />,
          },
          {
            path: "reset-password",
            element: <ResetPasswordPage />,
          },
        ],
      },

      // Public login routes (easy access)
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },

      // Protected routes
      {
        path: "/",
        element: (
          <AuthGuard>
            <Layout />
          </AuthGuard>
        ),
        errorElement: <NotFoundPage />,
        children: [
          // Dashboard
          {
            path: "dashboard",
            element: <DashboardPage />,
          },

          // Orders
          {
            path: "orders",
            children: [
              {
                index: true,
                element: <OrdersPage />,
              },
              {
                path: ":id",
                element: <OrderDetailsPage />,
              },
              {
                path: "create",
                element: <CreateOrderPage />,
              },
            ],
          },

          // Menu
          {
            path: "menu",
            children: [
              {
                index: true,
                element: <MenuProductsPage />,
              },
              {
                path: "categories",
                element: <MenuCategoriesPage />,
              },
              {
                path: "products",
                element: <MenuProductsPage />,
              },
              {
                path: "products/:id",
                element: <ProductDetailsPage />,
              },
              {
                path: "products/create",
                element: <CreateProductPage />,
              },
            ],
          },

          // Customers
          {
            path: "customers",
            children: [
              {
                index: true,
                element: <CustomersPage />,
              },
              {
                path: ":id",
                element: <CustomerDetailsPage />,
              },
              // {
              //   path: "create",
              //   element: <CustomerPage />,
              // },
            ],
          },

          // Inventory
          {
            path: "inventory",
            children: [
              {
                index: true,
                element: <InventoryPage />,
              },
              {
                path: ":id",
                element: <InventoryItemPage />,
              },
              // {
              //   path: "transactions",
              //   element: <InventoryTransactionsPage />,
              // },
            ],
          },

          // Reports
          {
            path: "reports",
            children: [
              {
                index: true,
                element: <ReportsPage />,
              },
              {
                path: "sales",
                element: <SalesReportPage />,
              },
              {
                path: "items",
                element: <ItemsReportPage />,
              },
              {
                path: "revenue",
                element: <RevenueReportPage />, // Tendrías que crear este componente
              },
              // {
              //   path: "delivery",
              //   element: <DeliveryReportPage />,
              // },
            ],
          },

          // Settings
          {
            path: "settings",
            children: [
              {
                index: true,
                element: <SettingsPage />,
              },
              {
                path: "restaurant",
                element: <SettingsPage />,
              },
              {
                path: "payment",
                element: <PaymentMethodsPage />,
              },
              // {
              //   path: "taxes",
              //   element: <TaxesPage />,
              // },
              // {
              //   path: "order-status",
              //   element: <OrderStatusesPage />,
              // },
            ],
          },

          // Users
          {
            path: "users",
            element: <UsersPage />,
          },
        ],
      },

      // Catch-all for 404
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

export default router;
